<template>
  <VaccinationPage
    title="HIV"
    :buttons="buttons"
    baseRoute="/HIVSecondPage"
    :bottomImage="require('@/assets/page14/Asset 120.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/HIVSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page14/Asset 104.png"), name: "Influenza" },
  { imgPath: require("@/assets/page14/Asset 105.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page14/Asset 106.png"), name: "RSV" },
  { imgPath: require("@/assets/page14/Asset 107.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page14/Asset 110.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page14/Asset 111.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page14/Asset 112.png"), name: "Zoster" },
  { imgPath: require("@/assets/page14/Asset 113.png"), name: "MMR" },
  { imgPath: require("@/assets/page14/Asset 115.png"), name: "Varicella" },
  { imgPath: require("@/assets/page14/Asset 116.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page14/Asset 117.png"), name: "Meningococcal" },
  { imgPath: require("@/assets/page14/Asset 118.png"), name: "Humanpapilloma" },
];
</script>